export default __webpack_public_path__ + "static/media/BrandBoxes.39549e70.png";